const percentageData = [
    { name: "Car", value: 30 },
    { name: "SUV", value: 20 },
    { name: "Pickup", value: 10 },
    { name: "Truck", value: 15 },
    { name: "Sedan", value: 25 },
  ];
export default percentageData;